const REWRITE_CONFIG = {
  'beehiiv-images-production.s3.amazonaws.com': 'media.beehiiv.com',
  'beehiiv-images-production.s3.us-east-1.amazonaws.com': 'media.beehiiv.com',
  'media.beehiiv.net': 'media.beehiiv.com',
  'beehiiv-images-staging.s3.amazonaws.com': 'media.staginghiiv.com',
  'beehiiv-images-staging.s3.us-east-1.amazonaws.com': 'media.staginghiiv.com',
  'staging-media.beehiiv.net': 'media.staginghiiv.com',
};

const rewriteImageSrc = (
  src: string,
  options: { [key: string]: string } = {
    format: 'auto',
    fit: 'scale-down',
    onerror: 'redirect',
  },
) => {
  let srcURL: URL | null = null;

  try {
    srcURL = new URL(src);
  } catch {
    // do nothing
  }

  const isRewritable = Boolean(srcURL && Object.keys(REWRITE_CONFIG).includes(srcURL.hostname));

  if (!isRewritable) return src;

  const cdnHost = srcURL ? REWRITE_CONFIG[srcURL.hostname as keyof typeof REWRITE_CONFIG] : '';

  const optionsToString = new URLSearchParams(options).toString().replace(/&/g, ',');

  return `https://${cdnHost}/cdn-cgi/image/${optionsToString}${srcURL?.pathname || ''}`;
};

export { rewriteImageSrc };
